import { REJECTION_REASONS } from 'consts/common';
import { Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DefaultModalProps,
  useOpenModal,
  withLocationStateModal,
} from 'utils/modals';

import { Box, Button, Grid } from '@mui/material';

import { ConnectedSelect } from '@libs/ui/components/form/select';
import { DefaultModal } from '@libs/ui/components/modals';
import Typography from '@libs/ui/components/typography';

import { MODAL_TYPES } from '../../consts';
import { useDeclineAction } from './hooks';
import { DeclineModalData, FormState } from './types';

interface DeclineModalProps extends DefaultModalProps<DeclineModalData> {
  jobId: string;
}

const DeclineModalComponent = ({
  jobId,
  close,
  isOpen,
  modalData,
}: DeclineModalProps) => {
  const { t } = useTranslation('job');
  const matchId = modalData?.matchId || '';
  const firstName = modalData?.firstName || 'a candidate';
  const { onSubmit, loading } = useDeclineAction({
    jobId,
    matchId,
    onClose: close,
  });

  return (
    <Formik<FormState> initialValues={{}} onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <DefaultModal
          actions={
            <Grid spacing={4} container>
              <Grid xs={6} item>
                <Button
                  fullWidth
                  color="primary"
                  variant="contained"
                  onClick={() => handleSubmit()}
                  disabled={loading}
                >
                  {t('v1.declineModal.decline')}
                </Button>
              </Grid>
              <Grid xs={6} item>
                <Button
                  fullWidth
                  variant="outlined"
                  color="secondary"
                  onClick={close}
                  disabled={loading}
                >
                  {t('v1.cancel')}
                </Button>
              </Grid>
            </Grid>
          }
          handleClose={close}
          open={isOpen}
          title={t('v1.declineModal.title', { firstName })}
        >
          <Box mt={4}>
            <Typography paragraph>
              {t('v1.declineModal.confirmText')}
            </Typography>
          </Box>

          <Box style={{ textAlign: 'left' }}>
            <ConnectedSelect
              name="reason"
              hideNoneValue
              fullWidth
              options={REJECTION_REASONS}
              variant="filled"
              label={t('v1.declineModal.reason')}
              size="small"
            />
          </Box>
        </DefaultModal>
      )}
    </Formik>
  );
};

export const DeclineModal = withLocationStateModal<DeclineModalData>({
  id: MODAL_TYPES.DECLINE,
})(DeclineModalComponent);

export const useOpenDeclineModal = () =>
  useOpenModal<DeclineModalData>(MODAL_TYPES.DECLINE);
